import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { IconButton } from '@mui/material';
import { GridCloseIcon } from '@mui/x-data-grid';
import PropTypes from 'prop-types';
import { Box } from '@mui/system';
import DropDownIcon from '../../Assets/Images/dropDownIcon.svg';
import DropDownIconBlack from '../../Assets/Images/arrowdropdown.svg';
import DropDownListIcon from '../../Assets/Images/dropdownListIcon.svg';
import PencilIcon from '../../Assets/Images/pencilEditIcon.svg';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: (ITEM_HEIGHT * 4.5) + ITEM_PADDING_TOP,
			maxWidth: '200px',
			overflowX: 'auto',
			scrollbarWidth: 'thin' // For Firefox
		}
	},
	MenuListProps: {
		disablePadding: true,
		onMouseDown(event) {
			event.preventDefault();
		}
	}
};
const MenuProps2 = {
	PaperProps: {
		style: {
			maxHeight: (ITEM_HEIGHT * 4.5) + ITEM_PADDING_TOP,
			maxWidth: '200px',
			overflowX: 'auto',
			scrollbarWidth: 'thin' // For Firefox
		}
	},
	MenuListProps: {
		disablePadding: true,
		onMouseDown(event) {
			event.preventDefault();
		}
	}
};

const DropDownIconComponent = ({ esign, background }) => {
	const getDropDownIcon = (esign, background) => {
		if (esign) {
			return DropDownListIcon;
		}

		if (background) {
			return DropDownIconBlack;
		}

		return DropDownIcon;
	};

	const iconSrc = getDropDownIcon(esign, background);

	return (
		<img
			style={{ pointerEvents: 'none', position: 'absolute', right: 15 }}
			src={iconSrc}
			className='MuiSvgIcon-root MuiSelect-icon'
			alt=''
		/>
	);
};

DropDownIconComponent.propTypes = {
	esign: PropTypes.any,
	background: PropTypes.any
};

export default function DropDown({
	isRecipientPage = false,
	placeholder,
	placeholderColor = '#8E8E8E',
	dropdownValue,
	defaultValue,
	width,
	borderColor = '#ECF0E5',
	name,
	dropDownSelected,
	handleChange,
	handlePenClick = () => {},
	className,
	disabled,
	searchDropdown,
	options,
	background = '',
	multiple = false,
	height,
	borderTopRightRadius,
	selectDisplayProps,
	selectStyles,
	showClear,
	disableClearable,
	iconComponent,
	disableMenuItem = [],
	clearAll,
	handleClearSelection,
	showIconItems = [],
	styles = {},
	innerStyles = { border: `1px solid ${borderColor}` },
	divStyles = {},
	borderRadius = '4px',
	isArticleCode = false
}) {
	const hasSelection
		= Array.isArray(dropDownSelected)
		&& dropDownSelected.some((ele) => ele.length > 0);
	showClear &&= hasSelection;

	const styles1 = isRecipientPage ? { width: '100%', borderRadius: '8px' } : {};

	return (
		<div style={divStyles}>
			<FormControl sx={{ width }}>
				{searchDropdown ? (
					<Autocomplete
						disableClearable={disableClearable}
						id='grouped-demo'
						options={options || []}
						value={dropDownSelected}
						onChange={handleChange}
						style={{ maxHeight: '200px' }}
						sx={{
							boxShadow: 'none',
							'.MuiOutlinedInput-notchedOutline': {
								border: `1px  solid ${borderColor}`
							},
							'&:hover': {
								'&& fieldset': {
									border: `1px solid${borderColor}`
								}
							},
							'.MuiOutlinedInput-root': {
								padding: '4px',
								paddingLeft: '4px',
								paddingRight: '40px',
								fontFamily: 'Gilroy-Medium ,sans-serif',
								fontSize: '14px'
							},
							'.MuiAutocomplete-hasPopupIcon .MuiAutocomplete-hasClearIcon .MuiAutocomplete-root .MuiOutlinedInput-root':
								{
									paddingRight: '53px'
								}
						}}
						renderInput={(params) => (
							<TextField {...params} placeholder={placeholder} />
						)}
					/>
				) : (
					<>
						<Select
							disabled={disabled}
							style={{
								backgroundcolor: isRecipientPage ? 'white' : 'transparent',
								...selectStyles
							}}
							SelectDisplayProps={{ style: selectDisplayProps }}
							sx={{
								position: 'relative',
								height,
								background: background || null,
								borderTopRightRadius: isRecipientPage
									? '0px'
									: borderTopRightRadius || null,
								boxShadow: 'none',
								minHeight: 0,
								...styles,
								'.MuiOutlinedInput-notchedOutline': {
									...innerStyles,
									...styles1,
									minHeight: 0,
									borderRadius
								},
								...(disabled
									? {}
									: {
										'&:hover': {
											'&& fieldset': {
												...innerStyles
											}
										}
									}),
								'.MuiSelect-select': {
									padding: '9px',
									minHeight: 'unset !important'
								},
								...(iconComponent ? { '.MuiSelect-icon': { top: '3px' } } : {})
							}}
							IconComponent={iconComponent || DropDownIconComponent}
							displayEmpty
							value={dropDownSelected}
							name={name}
							multiple={multiple}
							className={className}
							onChange={handleChange}
							defaultValue={defaultValue || ''}
							renderValue={(selected) => {
								if (multiple ? selected?.length === 0 : !selected) {
									return (
										<div
											className='medium6'
											style={{
												color: placeholderColor,
												minHeight: 0
											}}
										>
											{placeholder}
										</div>
									);
								}

								if (multiple) {
									let selectedOption = [];
									if (Array.isArray(selected)) {
										if (selected.every((value) => typeof value === 'number')) {
											selectedOption = dropdownValue?.filter((option) =>
												selected.includes(option.id)
											);
										} else {
											selectedOption = dropdownValue.filter(
												(option) =>
													selected.includes(option.name)
													|| selected.includes(option.id)
											);
										}
									} else {
										selectedOption = dropdownValue.find(
											(option) => selected === option.id
										);
										selectedOption ||= dropdownValue.find(
											(option) => selected === option.name
										);

										selectedOption = selectedOption ? [selectedOption] : [];
									}

									return selectedOption?.map((e) => e.name).join(', ');
								}

								const selectedOption = dropdownValue.find(
									(option) => option.id === selected
								);
								return (
									<div className='medium6'>
										{selectedOption ? selectedOption.name : selected}
									</div>
								);
							}}
							input={<OutlinedInput sx={{ border: 0 }} />}
							MenuProps={isArticleCode ? MenuProps2 : MenuProps}
						>
							{clearAll?.clear && (
								<MenuItem
									key='clearAll'
									value={clearAll?.id}
									style={{ padding: 12 }}
								>
									{clearAll?.name}
								</MenuItem>
							)}
							{dropdownValue?.map((val, i) => (
								<MenuItem
									key={val?.id || val}
									value={val?.id || val}
									style={{
										padding: 12,
										backgroundColor: multiple
											? ((dropDownSelected?.includes(val?.id || val)
												&& 'rgb(235 241 205)')
												|| 'transparent')
											: undefined
									}}
									disabled={
										disableMenuItem[i] === 0 || disableMenuItem.includes(val)
									}
								>
									<span>{val?.name || val}</span>
									{showIconItems.includes(val)
									|| showIconItems.includes(val?.name || '') ? (
											<Box
												component='img'
												src={PencilIcon}
												alt='menu item icon'
												style={{
													marginLeft: 'auto',
													width: '16px',
													height: '16px'
												}}
												onClick={() => {
													handlePenClick(val?.id || val);
												}}
											/>
										) : null}
								</MenuItem>
							))}
						</Select>
						{showClear && (
							<IconButton
								aria-label='clear'
								onClick={handleClearSelection}
								size='small'
								sx={{
									position: 'absolute',
									right: 35,
									top: 'calc(50% - 12px)',
									padding: 0
								}}
							>
								<GridCloseIcon fontSize='small' />
							</IconButton>
						)}
					</>
				)}
			</FormControl>
		</div>
	);
}

DropDown.propTypes = {
	isRecipientPage: PropTypes.any,
	placeholder: PropTypes.any,
	placeholderColor: PropTypes.any,
	dropdownValue: PropTypes.any,
	width: PropTypes.any,
	borderColor: PropTypes.any,
	name: PropTypes.any,
	dropDownSelected: PropTypes.any,
	handleChange: PropTypes.any,
	handlePenClick: PropTypes.any,
	className: PropTypes.any,
	disabled: PropTypes.any,
	searchDropdown: PropTypes.any,
	options: PropTypes.any,
	background: PropTypes.any,
	multiple: PropTypes.any,
	height: PropTypes.any,
	borderTopRightRadius: PropTypes.any,
	selectDisplayProps: PropTypes.any,
	selectStyles: PropTypes.any,
	showClear: PropTypes.any,
	disableClearable: PropTypes.any,
	iconComponent: PropTypes.any,
	disableMenuItem: PropTypes.any,
	clearAll: PropTypes.any,
	handleClearSelection: PropTypes.any,
	showIconItems: PropTypes.any,
	styles: PropTypes.any,
	innerStyles: PropTypes.any,
	divStyles: PropTypes.any,
	borderRadius: PropTypes.any,
	isArticleCode: PropTypes.any
};
